
import { Options, Vue } from "vue-class-component";
import type {
  EquipmentAndStatistics,
  SchUnschHours,
} from "../../types/equipment-statistics";
import { mapActions, mapGetters } from "vuex";
import EquipmentSystem from "../equipment/EquipmentSystem.vue";
import EquipmentModel from "../equipment/EquipmentModel.vue";
import EquipmentTag from "../equipment/EquipmentTag.vue";
import CriticalFilter from "../equipment-list/CriticalFilter.vue";
import { ReportingViewType } from "../../types/reporting-view";
import _ from "lodash";
import fp from "lodash/fp";
import { Equipment } from "../../types/equipment";
import EditEquipmentCommentPopin from "../equipment-details/EditEquipmentCommentPopin.vue";
import { EquipmentComment } from "../../types/equipment-comment";
import Moment from "moment";
import { UserRole } from "../../types/user-info";
import { extendMoment } from "moment-range";
import {
  EquipmentStatus,
  EquipmentStatuses,
} from "../../types/equipment-status";
import { StatusEventEnum } from "../../types/status-events";
import { equipmentStatuses } from "@/helpers/equipment-status-helpers";
import emitter from "../../store/eventBus";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import { applyPlugin } from "jspdf-autotable";
import "jspdf-autotable";
import base64IMG from "../../store/base64Images";
import CriticalCheckbox from "../equipment-list/CriticalFilter.vue";
const moment = extendMoment(Moment as any);

@Options({
  props: {
    equipment: {
      type: Object,
      required: false,
    },
  },
  components: {
    EquipmentSystem,
    EquipmentModel,
    EquipmentTag,
    EditEquipmentCommentPopin,
    CriticalFilter,
  },
  methods: {
    ...mapActions([
      "reportPageLoaded",
      "reportReset",
      "equipmentDetailsReset",
      "updateCommentsInReportingList",
      "reportsUpdated",
      "displayHttpErrorDialog",
      "reportPageLoadedKPI",
      "updateFilters",
      "reportsUpdatedReset",
    ]),
  },
  computed: {
    ...mapGetters([
      "getEquipmentStatisticsList",
      "getReportingView",
      "getEquipmentListForWeeklyReport",
      "getSelectedSite",
      "getEquipmentDetails",
      "EquipmentDetails",
      "getSelectedSite",
      "getUserRole",
      "getSelectedCountryBloc",
      "getIsReportingWeeklyReportExpanded",
      "getDateRangeForWeeklyReport",
    ]),
  },
  data() {
    return {
      expansion_items: {},
      startDate: "",
      endDate: "",
      showPageLoadingInfo: false,
      pageLoadingInfo: "Loading weekly report data...",
    };
  },
  watch: {
    getIsReportingWeeklyReportExpanded(newVal) {
      Object.keys(this.expansion_items).forEach((key) => {
        this.expansion_items[key] = newVal;
      });
    },
    getReportingView: function (val) {
      let initialSDate = moment().startOf("week").format("DD-MM-YYYY");
      let initialEDate = moment().endOf("week").format("DD-MM-YYYY");
      if (
        this.getReportingView === ReportingViewType.BARCHART &&
        this.startDate === initialSDate &&
        this.endDate === initialEDate
      ) {
        this.startDate = "";
        this.endDate = "";
      }
    },
  },
  name: "ReportingCard",
})
export default class ReportingCard extends Vue {
  criticalCheckboxFilter = false;
  fromDate = new Date();
  toDate = new Date();
  unschHours = 0;
  schHours = 0;
  nbrTrips = 0;
  ReportingViewType = ReportingViewType;
  getEquipmentStatisticsList!: EquipmentAndStatistics;
  getEquipmentListForWeeklyReport!: Equipment[];
  getReportingView!: string;
  pageLoadingInfo!: string;
  showPageLoadingInfo!: boolean;
  getIsReportingWeeklyReportExpanded!: boolean;
  reportPageLoaded!: () => void;
  reportReset!: () => void;
  singleMainKey: string;
  subHeaderName: string;
  getDateRangeForWeeklyReport!: string;
  expansion_items!: { [key: string]: boolean };
  equipmentDetailsReset!: () => void;
  reportsUpdatedReset!: () => void;
  updateCommentsInReportingList!: ({
    equipmentId,
    equipmentComment,
  }: {
    equipmentId: number;
    equipmentComment: EquipmentComment;
  }) => void;
  reportsUpdated!: ({ fromDate, toDate }: any) => Promise<void>;
  reportPageLoadedKPI!: ({ fromDate, toDate }: any) => Promise<void>;
  getSelectedSite!: string;
  updateEquipmentDetails!: (equipment: Equipment) => Promise<void>;
  getEquipmentDetails!: Equipment;
  equipment!: Equipment;
  manualSortList = [
    "Critical and safety systems",
    "Critical systems",
    "Safety systems",
    "Electric energy",
    "Produced gas processing",
    "Produced liquid processing",
    "Produced water system",
    "Water processing",
    "Subsea processing",
    "Chemical injection",
    "Drain system",
    "Other utilities",
    "Electrical equipment",
    "HVAC",
    "Lifting equipment",
    "Marine",
    "Buoy",
    "Drilling equipment",
    "Dan Bravo",
    "Dagmar",
    "Kraka",
    "Rolf",
    "Roar",
    "Svend",
    "Tyra South East A",
    "Tyra South East B",
    "Valdemar",
  ];
  startDate!: string;
  endDate!: string;
  getUserRole!: UserRole;

  displayHttpErrorDialog!: ({
    displayHttpErrorDialog,
    httpErrorMessage,
  }: {
    displayHttpErrorDialog: boolean;
    httpErrorMessage: string;
  }) => void;
  getSelectedCountryBloc!: string;

  callJsPDF() {
    this.$q.loading.show();
    const weeklyData = this.equipmentsGroupedBySystemAndModelAndDesc;
    const { jsPDF } = require("jspdf");
    require("jspdf-autotable");
    applyPlugin(jsPDF);
    let heading = "Download path: ";
    let pageURL = this.$route.path.replace(/%20/g, " ");
    let dateRange = this.getDateRangeForWeeklyReport;
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "cm",
      format: "letter",
    });
    doc.setFontSize(12).text("OneCBM Weekly Report: " + dateRange, 3.2, 1.27);
    doc.setFontSize(10).text(heading, 3.2, 1.8);
    doc.setFontSize(10).text(pageURL, 5.7, 1.8);
    doc.setLineWidth(0.006).line(1.27, 2.15, 20.2, 2.15);

    let mainTitleArray = Object.keys(weeklyData).filter((x) => weeklyData[x]);
    for (let i in mainTitleArray) {
      let tblData: any = {};
      let mainKey,
        subKey = "";
      let finalY: number;
      let in_obj,
        subTitleArray,
        itemObj = {};
      mainKey = mainTitleArray[i];
      tblData.MainTitle = mainKey;
      in_obj = weeklyData[mainKey];
      subTitleArray = Object.keys(in_obj).filter((x) => in_obj[x]);
      for (let i in subTitleArray) {
        subKey = subTitleArray[i];
        tblData.item = [];
        let sortedArray = [];
        sortedArray = in_obj[subKey].map((e) => ({
          tag: e?.tag || "",
          status: e?.lastEquipmentStatus?.status.toUpperCase() || "",
          sch: e?.sch + " h" || "",
          unsch: e?.unsch + " h" || "",
          weekReportComment:
            e?.weeklyReportComments.length > 0
              ? e?.weeklyReportComments[0].comment
              : "",
          availReliab:
            this.formatter(e?.availability) +
              "%" +
              " ".repeat(2) +
              this.formatter(e?.reliability) +
              "%" || "-% " + " ".repeat(2) + " -%",
          availReliabStatus: this.getPdfIconAvlRel(
            e?.availability,
            e?.reliability
          ),
        }));
        itemObj[subKey] = sortedArray;
        tblData.item.push(itemObj);
      }
      if (doc.lastAutoTable.finalY) {
        finalY = doc.lastAutoTable.finalY + 1;
      } else {
        finalY = 2.54;
      }
      this.printPDF(doc, finalY, tblData);
      tblData = {};
    }

    // saving file
    doc.save(`OneCBM Report${pageURL}.pdf`);
    // Reset defaults
    doc.autoTableSetDefaults(null);
    jsPDF.autoTableSetDefaults(null);
    this.$q.loading.hide();
    this.showNotif();
  }

  printPDF(doc, finalY, tblData) {
    let mainTableHeight;
    let tblItems = tblData.item;
    tblItems.forEach((key) => {
      let tblRowHeight = 0;
      let tblHeadHeight = 0;
      let value;
      for (let j in key) {
        value = tblItems[0][j].length;
        tblRowHeight = tblRowHeight + value * 1;
        tblHeadHeight = tblHeadHeight + 1.25;
      }
      mainTableHeight = tblRowHeight + tblHeadHeight;
    });

    doc.autoTable({
      tableLineWidth: 0.026,
      tableWidth: "auto",
      startY: finalY,
      pageBreak: "avoid",
      showHead: "firstPage",
      body: [[{ content: "", styles: { minCellHeight: mainTableHeight } }]],
      head: [
        [
          {
            content: tblData.MainTitle,
            styles: {
              cellPadding: 0.25,
              halign: "left",
              fillColor: [224, 224, 224],
              fontSize: 12,
              fontStyle: "normal",
              textColor: [55, 70, 73],
            },
          },
        ],
      ],
      margin: { left: 1.27, top: 1.9 },
      didDrawCell: function (obj) {
        if (obj.row.index === 0 && obj.row.section === "body") {
          let tHeight = obj.cell.y;
          for (let subKeyName in tblData.item[0]) {
            doc.autoTable({
              startY: tHeight + 0.13,
              showHead: "firstPage",
              theme: "striped",
              tableWidth: obj.cell.width,
              styles: { fontSize: 9 },
              head: [
                [
                  {
                    content: subKeyName,
                    colSpan: 7,
                    styles: {
                      halign: "left",
                      fillColor: [255, 255, 255],
                      fontSize: 10,
                      fontStyle: "normal",
                      textColor: [55, 70, 73],
                    },
                  },
                ],
                ["Tag", "Status", "", "SCH", "UNSCH", "", "Avail. Reliab."],
              ],
              columns: [
                { dataKey: "tag", header: "Tag", styles: { halign: "center" } },
                { dataKey: "status", header: "Status" },
                {
                  dataKey: "weekReportComment",
                  header: "Weekly Report Comment",
                  styles: { halign: "center" },
                },
                { dataKey: "sch", header: "SCH", styles: { halign: "right" } },
                {
                  dataKey: "unsch",
                  header: "UNSCH",
                  styles: { halign: "right" },
                },
                {
                  dataKey: "availReliabStatus",
                  header: "",
                  styles: { halign: "left" },
                },
                {
                  dataKey: "availReliab",
                  header: "Avail. Reliab.",
                  styles: { halign: "left" },
                },
              ],
              body: tblData.item[0][subKeyName],
              willDrawPage: function (data) {
                doc.addImage(
                  base64IMG.oneCBMBase64,
                  "PNG",
                  1.27,
                  0.75,
                  1.88,
                  1.06
                );
                doc.addImage(
                  base64IMG.totalBase64,
                  "PNG",
                  18.5,
                  0.7,
                  1.58,
                  1.15
                );
              },
              didDrawPage: function (data) {
                let str = "Copyright © TotalEnergies propoerty";
                doc.setFontSize(9).setFont(undefined, "normal");

                // jsPDF 1.4+ uses getHeight, <1.4 uses .height
                const pageSize = doc.internal.pageSize;
                const pageHeight = pageSize.height
                  ? pageSize.height
                  : pageSize.getHeight();
                doc.text(str, data.settings.margin.left, pageHeight - 1);
              },
              didDrawCell: async (data) => {
                if (
                  data.section === "body" &&
                  data.column.dataKey === "status"
                ) {
                  let base64StatusImg;
                  switch (data.cell.raw) {
                    case "RUN":
                      base64StatusImg = base64IMG.runBase64;
                      break;
                    case "RUN_LIMITED":
                      base64StatusImg = base64IMG.runUnlimitedBase64;
                      break;
                    case "ABNR":
                      base64StatusImg = base64IMG.abnrBase64;
                      break;
                    case "SCHEDULED":
                      base64StatusImg = base64IMG.scheduledBase64;
                      break;
                    case "UNSCHEDULED":
                      base64StatusImg = base64IMG.unscheduledBase64;
                      break;
                    default:
                      base64StatusImg = "noImage";
                  }
                  doc.addImage(
                    base64StatusImg,
                    "PNG",
                    data.cell.x + 0.35,
                    data.cell.y + 0.13,
                    0.45,
                    0.45
                  );
                }
                if (
                  data.section === "body" &&
                  data.column.dataKey === "availReliabStatus"
                ) {
                  let base64ARImg;
                  switch (data.cell.raw) {
                    case "good":
                      base64ARImg = base64IMG.goodBase64;
                      break;
                    case "fair":
                      base64ARImg = base64IMG.fairBase64;
                      break;
                    case "critical":
                      base64ARImg = base64IMG.criticalBase64;
                      break;
                    default:
                      base64ARImg = base64IMG.criticalBase64;
                  }
                  doc.addImage(
                    base64ARImg,
                    "PNG",
                    data.cell.x + 0.5,
                    data.cell.y + 0.13,
                    0.45,
                    0.45
                  );
                }
              },
              didParseCell: function (data) {
                if (
                  data.row?.raw[0]?.content !== subKeyName &&
                  data.row.section === "head"
                ) {
                  data.cell.styles.fillColor = [222, 232, 239];
                  data.cell.styles.textColor = [56, 73, 84];
                  data.cell.styles.fontStyle = "normal";
                }
                let headList = ["sch", "unsch", "availReliabStatus"];
                let keyLocation = data.column.dataKey;
                if (headList.includes(keyLocation)) {
                  data.cell.styles.halign = "right";
                }
                switch (keyLocation) {
                  case "tag":
                    data.cell.styles.cellWidth = 1.25;
                    break;
                  case "status":
                    data.cell.styles.cellWidth = 4;
                    data.cell.styles.cellPadding = {
                      top: 0.18,
                      right: 0.3,
                      bottom: 0,
                      left: 1,
                    };
                    break;
                  case "weekReportComment":
                    data.cell.styles.cellWidth = 5.9;
                    break;
                  case "sch":
                    data.cell.styles.cellWidth = 1.5;
                    break;
                  case "unsch":
                    data.cell.styles.cellWidth = 2;
                    data.cell.styles.cellPadding = {
                      top: 0.18,
                      right: 0.25,
                      bottom: 0,
                      left: 0,
                    };
                    break;
                  case "availReliabStatus":
                    data.cell.styles.cellWidth = 1;
                    break;
                  case "availReliab":
                    data.cell.styles.cellWidth = 3;
                    break;
                  default:
                    data.cell.styles.cellWidth = "auto";
                }
                if (data.column.dataKey === "availReliabStatus") {
                  data.cell.text = ""; // Use only for "availReliabStatus" icon in didDrawCell instead
                }
              },
              willDrawCell: function (data) {
                //text color of status
                if (
                  data.row.section === "body" &&
                  data.column.dataKey === "status"
                ) {
                  switch (data.cell.raw) {
                    case "RUN":
                    case "RUN_LIMITED":
                      doc.setTextColor(64, 169, 0);
                      break;
                    case "ABNR":
                      doc.setTextColor(108, 118, 120);
                      break;
                    case "SCHEDULED":
                      doc.setTextColor(239, 111, 0);
                      break;
                    case "UNSCHEDULED":
                      doc.setTextColor(209, 0, 0);
                      break;
                    default:
                      doc.setTextColor(224, 224, 224);
                  }
                }
              },
            });
            tHeight = doc.lastAutoTable.finalY;
          }
        }
      },
    });
  }

  async showNotif(): Promise<void> {
    this.$q.notify({
      message: "The Weekly Report PDF has been downloaded.",
      color: "positive",
      textColor: "black",
      actions: [{ icon: "close", color: "black" }],
    });
  }

  formatter(val: any): string {
    if (val === -1) return "-";
    if (val) return val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    else return "-";
  }

  getPdfIconAvlRel(
    availability: number | undefined,
    reliability: number | undefined
  ): string | undefined {
    if (availability != undefined && reliability != undefined) {
      if (availability > 95 && reliability > 97) {
        return "good";
      }
    }
    if (availability != undefined) {
      if (availability > 95) return "fair";
    }
    if (reliability != undefined) {
      if (reliability > 97) return "fair";
    }
    return "critical";
  }

  get isDataEmpty(): boolean {
    let data = this.equipmentsGroupedBySystemAndModelAndDesc;
    return (
      !data || (typeof data === "object" && Object.keys(data).length === 0)
    );
  }
  get equipmentsGroupedBySystemAndModelAndDesc(): EquipmentAndStatistics | any {
    if (this.getReportingView === ReportingViewType.WEEKLY) {
      let eqList = this.getEquipmentListForWeeklyReport;
      let tagIdarr: any[] = [];
      let tempEnquipmentName = "";

      eqList = eqList.filter(
        (eq: Equipment) =>
          eq.hasWeeklyReport || eq.weeklyReportComments?.length > 0
      );
      const equipmentsGroupedBySystem = _.groupBy(
        eqList,
        "equipmentModel.system"
      );
      const equipmentsGroupedBySystemManualOrdered = Object.keys(
        equipmentsGroupedBySystem
      )
        .sort(
          (a, b) =>
            this.manualSortList.indexOf(a) - this.manualSortList.indexOf(b)
        )
        .reduce((obj: any, key) => {
          obj[key] = equipmentsGroupedBySystem[key];
          return obj;
        }, {});

      const equipmentStatistics: EquipmentAndStatistics =
        this.getEquipmentStatisticsList;
      const schUnschHours: SchUnschHours = {};

      Object.keys(equipmentStatistics || {}).forEach((systemKey) => {
        const system = equipmentStatistics[systemKey];
        Object.keys(system).forEach((modelKey) => {
          const model = system[modelKey];
          const allStatuses = Object.keys(model || {}).reduce(
            (acc: EquipmentStatus[], nestedKey) => {
              const nestedModel = model[nestedKey];
              if (nestedModel?.equipments) {
                nestedModel.equipments.forEach((equipment: any) => {
                  const sortedStatuses = _.sortBy(
                    equipment.equipmentStatuses,
                    "date"
                  );
                  const filteredStatuses = _.filter(
                    sortedStatuses,
                    (status: EquipmentStatus, index: number) => {
                      const fromDateMoment = moment(this.fromDate);
                      const toDateMoment = moment(this.toDate);
                      return (
                        (moment(status.date).isSameOrAfter(fromDateMoment) &&
                          moment(status.date).isBefore(toDateMoment)) ||
                        (moment(status.date).isSameOrBefore(fromDateMoment) &&
                          moment(sortedStatuses[index + 1]?.date).isAfter(
                            fromDateMoment
                          ))
                      );
                    }
                  );
                  const hoursByStatuses = _.reduce(
                    filteredStatuses,
                    (acc: any, { status, date }, index) => {
                      if (moment(date).isBefore(moment(this.fromDate))) {
                        date = moment(this.fromDate).format();
                      }
                      const nextStatus = filteredStatuses[index + 1];
                      if (!acc[status]) acc[status] = 0;
                      if (nextStatus) {
                        acc[status] +=
                          +moment.range(moment(date), moment(nextStatus.date)) /
                          3600000;
                      } else {
                        acc[status] +=
                          +moment.range(moment(date), moment(this.toDate)) /
                          3600000;
                      }
                      return acc;
                    },
                    {}
                  );
                  let sch = hoursByStatuses[EquipmentStatuses.SCH] ?? 0;
                  let unsch = hoursByStatuses[EquipmentStatuses.UNSCH] ?? 0;
                  let run = hoursByStatuses[EquipmentStatuses.RUN] ?? 0;
                  let runLimited =
                    hoursByStatuses[EquipmentStatuses.RUN_LIMITED] ?? 0;
                  let abnr = hoursByStatuses[EquipmentStatuses.ABNR] ?? 0;

                  if (tagIdarr.length === 0) {
                    const obj = {
                      [equipment?.tag]: { sch, unsch, run, runLimited, abnr },
                    };
                    tempEnquipmentName = equipment.equipmentModel.name;
                    tagIdarr.push(obj);
                  } else if (
                    tempEnquipmentName == equipment.equipmentModel.name
                  ) {
                    tagIdarr.push({
                      [equipment?.tag]: { sch, unsch, run, runLimited, abnr },
                    });
                    tagIdarr.push({
                      [equipment?.tag]: { sch, unsch, run, runLimited, abnr },
                    });
                  } else {
                    tagIdarr = [];
                    tempEnquipmentName = equipment.equipmentModel.name;
                    tagIdarr.push({
                      [equipment?.tag]: { sch, unsch, run, runLimited, abnr },
                    });
                    tagIdarr.push({
                      [equipment?.tag]: { sch, unsch, run, runLimited, abnr },
                    });
                  }
                  schUnschHours[equipment.equipmentModel.name] = tagIdarr;
                });
              }
              return acc;
            },
            []
          );
        });
      });
      let equipmentsGroupedBySystemOrderedTagId: any = {};
      Object.keys(equipmentsGroupedBySystemManualOrdered).forEach((key) => {
        equipmentsGroupedBySystemOrderedTagId[key] = _.sortBy(
          equipmentsGroupedBySystemManualOrdered[key],
          "tagId"
        );
      });
      const equipmentsGroupedBySystemandModelandDesc = _.mapValues(
        equipmentsGroupedBySystemOrderedTagId,
        (groupedItems) => {
          const grouped = fp.groupBy(
            (obj: any) =>
              `${obj.equipmentModel?.name} (${obj.name_description})`,
            groupedItems
          );
          Object.keys(grouped).forEach((key) => {
            grouped[key].forEach((item) => {
              const equipmentName = item.equipmentModel?.name;
              const tag = item.tagId;
              let res: any;
              let groupedDataCritical;
              if (
                this.criticalCheckboxFilter &&
                item.equipmentModel?.category !== "Critical"
              ) {
                return;
              }
              console.log("groupedDataCritical", groupedDataCritical);
              if (tag == equipmentName + item.tag) {
                Array(schUnschHours).forEach((value) => {
                  Object.keys(value).forEach((key: any) => {
                    if (key === equipmentName) {
                      value[key].forEach((element) => {
                        if (Object.keys(element) == item.tag) {
                          res = element[item.tag];
                        }
                      });
                    }
                  });
                });
              }
              if (!res && schUnschHours[equipmentName]) {
                const noTagData = schUnschHours[equipmentName][0];
                res = {
                  sch: noTagData?.null?.sch ?? 0,
                  unsch: noTagData?.null?.unsch ?? 0,
                  run: noTagData?.null?.run ?? 0,
                  runLimited: noTagData?.null?.runLimited ?? 0,
                  abnr: noTagData?.null?.abnr ?? 0,
                };
              }
              item.sch = this.formatHours(res?.sch);
              item.unsch = this.formatHours(res?.unsch);
              item.run = this.formatHours(res?.run);
              item.runLimited = this.formatHours(res?.runLimited);
              item.abnr = this.formatHours(res?.abnr);
              item.run = this.formatHours(res?.run);
              item.runLimited = this.formatHours(res?.runLimited);
              item.abnr = this.formatHours(res?.abnr);
            });
          });
          return grouped;
        }
      );
      return equipmentsGroupedBySystemandModelandDesc;
    } else if (this.getReportingView === ReportingViewType.BARCHART) {
      let tagIdarr: any[] = [];
      let tempEnquipmentName = "";
      const equipmentsGroupedBySystemManualOrdered: EquipmentAndStatistics =
        Object.keys(this.getEquipmentStatisticsList)
          .sort(
            (a, b) =>
              this.manualSortList.indexOf(a) - this.manualSortList.indexOf(b)
          )
          .reduce((obj: any, key: any) => {
            obj[key] = this.getEquipmentStatisticsList[key];
            return obj;
          }, {});

      console.log(
        "equipmentgorupbysystem",
        equipmentsGroupedBySystemManualOrdered
      );

      const equipmentStatistics: EquipmentAndStatistics =
        this.getEquipmentStatisticsList;
      const schUnschHours: SchUnschHours = {};

      Object.keys(equipmentStatistics || {}).forEach((systemKey) => {
        const system = equipmentStatistics[systemKey];
        Object.keys(system).forEach((modelKey) => {
          const model = system[modelKey];
          const allStatuses = Object.keys(model || {}).reduce(
            (acc: EquipmentStatus[], nestedKey) => {
              const nestedModel = model[nestedKey];
              if (nestedModel?.equipments) {
                nestedModel.equipments.forEach((equipment: any) => {
                  const sortedStatuses = _.sortBy(
                    equipment.equipmentStatuses,
                    "date"
                  );
                  const filteredStatuses = _.filter(
                    sortedStatuses,
                    (status: EquipmentStatus, index: number) => {
                      const fromDateMoment = this.startDate
                        ? this.startDate
                        : moment(this.fromDate);
                      const toDateMoment = this.endDate
                        ? this.endDate
                        : moment(this.toDate);
                      return (
                        (moment(status.date).isSameOrAfter(fromDateMoment) &&
                          moment(status.date).isBefore(toDateMoment)) ||
                        (moment(status.date).isSameOrBefore(fromDateMoment) &&
                          moment(sortedStatuses[index + 1]?.date).isAfter(
                            fromDateMoment
                          ))
                      );
                    }
                  );
                  const hoursByStatuses = _.reduce(
                    filteredStatuses,
                    (acc: any, { status, date }, index) => {
                      if (
                        moment(date).isBefore(
                          this.startDate
                            ? this.startDate
                            : moment(this.fromDate)
                        )
                      ) {
                        date = this.startDate
                          ? this.startDate
                          : moment(this.fromDate).format();
                      }
                      const nextStatus = filteredStatuses[index + 1];
                      if (!acc[status]) acc[status] = 0;
                      if (nextStatus) {
                        acc[status] +=
                          +moment.range(moment(date), moment(nextStatus.date)) /
                          3600000;
                      } else {
                        acc[status] +=
                          +moment.range(
                            moment(date),
                            moment(
                              this.endDate ? this.endDate : moment(this.toDate)
                            )
                          ) / 3600000;
                      }
                      return acc;
                    },
                    {}
                  );
                  let sch = hoursByStatuses[EquipmentStatuses.SCH] ?? 0;
                  let unsch = hoursByStatuses[EquipmentStatuses.UNSCH] ?? 0;
                  let run = hoursByStatuses[EquipmentStatuses.RUN] ?? 0;
                  let runLimited =
                    hoursByStatuses[EquipmentStatuses.RUN_LIMITED] ?? 0;
                  let abnr = hoursByStatuses[EquipmentStatuses.ABNR] ?? 0;
                  let nbrTrip = filteredStatuses.filter(
                    (status) =>
                      status.status == EquipmentStatuses.UNSCH &&
                      status.event == StatusEventEnum.UNSCH_FAILURE
                  ).length;

                  let allEventsTotalHours =
                    run + runLimited + abnr + unsch + sch;
                  let utilizationRatio =
                    100 *
                    (((hoursByStatuses[EquipmentStatuses.RUN] ?? 0) +
                      (hoursByStatuses[EquipmentStatuses.RUN_LIMITED] ?? 0)) /
                      allEventsTotalHours);
                  if (tagIdarr.length === 0) {
                    const obj = {
                      [equipment?.tag]: {
                        sch,
                        unsch,
                        run,
                        runLimited,
                        abnr,
                        nbrTrip,
                        utilizationRatio,
                      },
                    };
                    tempEnquipmentName = equipment?.equipmentModel?.name;
                    tagIdarr.push(obj);
                  } else if (
                    tempEnquipmentName == equipment?.equipmentModel?.name
                  ) {
                    tagIdarr.push({
                      [equipment?.tag]: {
                        sch,
                        unsch,
                        run,
                        runLimited,
                        abnr,
                        nbrTrip,
                        utilizationRatio,
                      },
                    });
                  } else {
                    tagIdarr = [];
                    tempEnquipmentName = equipment?.equipmentModel?.name;
                    tagIdarr.push({
                      [equipment?.tag]: {
                        sch,
                        unsch,
                        run,
                        runLimited,
                        abnr,
                        nbrTrip,
                        utilizationRatio,
                      },
                    });
                  }
                  schUnschHours[equipment?.equipmentModel?.name] = tagIdarr;
                });
              }
              return acc;
            },
            []
          );
        });
      });
      let equipmentsGroupedBySystemOrderedTagId: any = {};
      Object.keys(equipmentsGroupedBySystemManualOrdered).forEach((key) => {
        equipmentsGroupedBySystemOrderedTagId[key] = _.sortBy(
          equipmentsGroupedBySystemManualOrdered[key],
          "tagId"
        );
      });
      // let grouped;
      const equipmentsGroupedBySystemAndModelAndDescD = _.mapValues(
        equipmentsGroupedBySystemOrderedTagId,
        (groupedItems) => {
          groupedItems.forEach((item) => {
            Object.keys(item).forEach((key) => {
              item[key].equipments.forEach((itemKey) => {
                if (
                  this.criticalCheckboxFilter &&
                  itemKey.equipmentModel?.category !== "Critical"
                ) {
                  return;
                }
                const grouped = fp.groupBy(
                  (obj: any) =>
                    `${itemKey.equipmentModel?.name} (${itemKey.name_description})`,
                  groupedItems
                );
                const equipmentName = itemKey.equipmentModel?.name;
                const tag = itemKey.tag;
                const comTag = equipmentName + tag;
                let res: any;

                if (comTag === equipmentName + itemKey.tag) {
                  Array(schUnschHours).forEach((value) => {
                    Object.keys(value).forEach((k: any) => {
                      if (k === equipmentName) {
                        value[k].forEach((element) => {
                          if (Object.keys(element) == itemKey.tag) {
                            res = element[itemKey.tag];
                          }
                        });
                      }
                    });
                  });
                }

                if (!res && schUnschHours[equipmentName]) {
                  const noTagData = schUnschHours[equipmentName][0];
                  res = {
                    sch: noTagData?.null?.sch ?? 0,
                    unsch: noTagData?.null?.unsch ?? 0,
                    run: noTagData?.null?.run ?? 0,
                    runLimited: noTagData?.null?.runLimited ?? 0,
                    abnr: noTagData?.null?.abnr ?? 0,
                    nbrTrip: noTagData?.null?.nbrTrip ?? 0,
                    utilizationRatio: noTagData?.null?.utilizationRatio ?? 0,
                  };
                }

                itemKey.sch = this.formatHours(res?.sch);
                itemKey.unsch = this.formatHours(res?.unsch);
                itemKey.run = this.formatHours(res?.run);
                itemKey.runLimited = this.formatHours(res?.runLimited);
                itemKey.abnr = this.formatHours(res?.abnr);
                itemKey.nbrTrip = res?.nbrTrip;
                itemKey.utilizationRatio = parseFloat(
                  res?.utilizationRatio?.toFixed(1)
                );
              });
            });
          });
          return groupedItems;
        }
      );

      if (this.criticalCheckboxFilter) {
        const filtered: any = {};

        Object.keys(equipmentsGroupedBySystemAndModelAndDescD).forEach(
          (systemKey) => {
            const system = equipmentsGroupedBySystemAndModelAndDescD[systemKey];
            const filteredSystem: any = {};

            Object.keys(system).forEach((key) => {
              const tagObj = system[key];

              Object.keys(tagObj).forEach((equipmentNameKey) => {
                const val = tagObj[equipmentNameKey];
                const criticalEquipments = (val.equipments || []).filter(
                  (equip: any) => equip?.equipmentModel?.category === "Critical"
                );

                criticalEquipments.forEach((equip: any) => {
                  const modelName = equip?.equipmentModel?.name;
                  const tag = equip?.name_description;

                  if (!filteredSystem[modelName]) {
                    filteredSystem[modelName] = {};
                  }

                  filteredSystem[modelName][tag] = {
                    ...val,
                    equipments: [equip],
                  };
                });
              });
            });

            if (Object.keys(filteredSystem).length > 0) {
              filtered[systemKey] = filteredSystem;
            }
          }
        );

        return filtered;
      }

      return equipmentsGroupedBySystemManualOrdered;
      // return {};
    }
  }
  get isCriticalDataEmpty(): boolean {
    return (
      this.criticalCheckboxFilter &&
      Object.keys(this.equipmentsGroupedBySystemAndModelAndDesc).length === 0
    );
  }
  formatHours(value: number): string {
    return `${Math.round(value)}`;
  }
  get filteredGroupedEquipments() {
    if (!this.criticalCheckboxFilter) {
      return this.equipmentsGroupedBySystemAndModelAndDesc;
    }

    const result = _.cloneDeep(
      this.equipmentsGroupedBySystemAndModelAndDesc || {}
    );

    Object.keys(result).forEach((systemKey) => {
      const groupArray = result[systemKey];

      if (Array.isArray(groupArray)) {
        result[systemKey] = groupArray.filter((groupItem: any) => {
          const equipmentList = groupItem.equipments || [];
          return (
            Array.isArray(equipmentList) &&
            equipmentList.some(
              (eq: any) => eq?.equipmentModel?.category === "Critical"
            )
          );
        });

        if (result[systemKey].length === 0) {
          delete result[systemKey];
        }
      } else {
        delete result[systemKey];
      }
    });

    return result;
  }

  async mounted(): Promise<void> {
    this.fromDate = new Date(this.getInitialDateRange().min);
    this.toDate = new Date(this.getInitialDateRange().max);
    this.reportPageLoaded();
    if (this.getReportingView === ReportingViewType.WEEKLY) {
      this.showPageLoadingInfo = true;
      this.pageLoadingInfo = "Loading weekly report data...";
      this.$q.loading.show();
      this.startDate = moment().startOf("week").format("DD-MM-YYYY");
      this.endDate = moment().endOf("week").format("DD-MM-YYYY");
      const toDate = moment(this.endDate, "DD MM YYYY hh:mm:ss").toDate();
      const fromDate = moment(this.startDate, "DD MM YYYY hh:mm:ss").toDate();

      this.pageLoadingInfo =
        "Loading comments and 12 months avl/rel data for each equipment in weekly report section...";
      await this.reportsUpdated({
        fromDate,
        toDate,
      });
      this.pageLoadingInfo = "data populated...";
      Object.keys(this.equipmentsGroupedBySystemAndModelAndDesc).forEach(
        (system: string) => {
          this.expansion_items["weekly-report-" + system] =
            this.getIsReportingWeeklyReportExpanded;
        }
      );
      this.showPageLoadingInfo = false;
      emitter.on("trigger-jsPDF", this.callJsPDF);
      this.$q.loading.hide();
    }
  }

  unmounted(): void {
    this.reportsUpdatedReset();
  }

  beforeUnmount(): void {
    this.reportReset();
    emitter.off("trigger-jsPDF", this.callJsPDF);
  }
  expand(): void {
    window.dispatchEvent(new Event("resize"));
  }

  onClosedEditEquipmentCommentPopin(): void {
    this.equipmentDetailsReset();
  }

  updatedEquipmentComment(
    equipmentId: number,
    equipmentComment: EquipmentComment
  ): void {
    this.updateCommentsInReportingList({ equipmentId, equipmentComment });
  }
  startDateOptions(date: any): boolean {
    const currentDate = moment(moment()).format("YYYY/MM/DD");
    if (this.endDate != null && this.endDate.toLocaleString() != "") {
      let localEndDate = new Date(this.endDate);
      const minStartDatePossible = moment(
        localEndDate.setMonth(localEndDate.getMonth() - 18)
      ).format("YYYY/MM/DD");
      return (
        date <= currentDate &&
        date >= minStartDatePossible &&
        date <= this.endDate
      );
    } else {
      return date <= currentDate;
    }
  }
  endDateOptions(date: any): boolean {
    let endDate = new Date(this.startDate);
    const currentDate = moment(moment()).format("YYYY/MM/DD");
    const endDates = moment(endDate.setMonth(endDate.getMonth() + 18)).format(
      "YYYY/MM/DD"
    );
    let startDateFormatted = moment(this.startDate).format("YYYY/MM/DD");
    return (
      date >= startDateFormatted && date <= currentDate && date <= endDates
    );
  }
  async apply(): Promise<void> {
    if (this.startDate && this.endDate) {
      this.$q.loading.show();
      const fromDate = this.startDate;
      const toDate = this.endDate;
      await this.equipmentsGroupedBySystemAndModelAndDesc;
      await this.reportPageLoadedKPI({
        fromDate,
        toDate,
      });
      this.$q.loading.hide();
    }
  }
  getInitialDateRange(): any {
    const toDate = moment();
    const fromDate = moment().subtract(12, "months");
    return {
      min: fromDate,
      max: toDate,
    };
  }
}
